<template>
  <div class="productbox" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="contain">
      <div class="topboxs">
        <div class="catbox">
          <div
            v-for="(item, index) in catlist"
            :key="index"
            class="catitem"
            :class="{ bgitem: cuurentpa == item.id }"
            @click="change(item.id)"
          >
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="seachbox">
          <el-autocomplete
            style="width: 240px"
            v-model="formData.keywords"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入关键字"
            clearable
          >
            <template #prepend>
              <el-button :icon="Search" @click="getseach" /> </template
          ></el-autocomplete>
        </div>
      </div>
      <el-tabs
        class="list-tabs mb5"
        v-model="formData.classId"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(item, index) in headeNum"
          :label="item.name"
          :name="item.id.toString()"
          :key="index"
        />
      </el-tabs>

      <div class="flex productlist">
        <div
          class="item"
          v-for="(item, index) in productList"
          :key="index"
          @click="godetail(item.id)"
        >
          <div class="picture">
            <img :src="item.image" alt="" />
          </div>
          <p class="productname">{{ item.productName }}</p>
          <div class="btnbox" @click.stop="touch(item.id)">
            <p class="">一键下载</p>
          </div>
        </div>
      </div>
      <div class="demo-pagination-block">
        <el-pagination
          v-model:current-page="formData.page"
          :page-size="formData.limit"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleSizeChange"
          prev-text="上一页"
          next-text="下一页"
        />
      </div>
    </div>
    <el-backtop :right="100" :bottom="100" />
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  getCurrentInstance,
} from "vue";
import {
  proListApi,
  categoryListApi,
  keywordListApi,
  parentCategoryApi,
  producttZipApi,
} from "@/api/index.js";
import { useRouter } from "vue-router";
import { Search } from "@element-plus/icons-vue";
import {ElMessage } from 'element-plus';
const { proxy } = getCurrentInstance();
const router = useRouter();
let formData = ref({
  classId: "1",
  keywords: null,
  limit: 25,
  page: 1,
  pid:0,
});
let fullscreenLoading = ref(false);
onMounted(() => {
  getPaCategoryList();
  getCategoryList();
  setTimeout(() => {
    getList();
  }, 100);
});

//一键下载
const touch = (id) => {
  fullscreenLoading.value = true;
  producttZipApi({ id })
    .then((res) => {
      window.open(res);
      ElMessage.success("下载成功");
      fullscreenLoading.value = false;
    })
    .catch((err) => {
      console.log(err);
      fullscreenLoading.value = false;
    });
};
let cuurentpa = ref("0");
// 改变大类
const change = (val) => {
  cuurentpa.value = val;
  formData.value.pid = val;
  getCategoryList();
  setTimeout(() => {
    getList();
  }, 100);
};
const getseach = () => {
  formData.value.page = 1;
  formData.value.classId = "0";
  getList();
};
const handleSizeChange = (val) => {
  formData.value.page = val;
  getList();
};
// 跳转到详情页
const godetail = (val) => {
  let formdata = JSON.stringify(formData.value);
  window.open(
    `https://www.laolesiyun.com/productdetail?id=${val}&formData=${formdata}`,
    "_blank"
  );
};
const handleClick = (tab, event) => {
  formData.value.classId = tab.props.name;
  formData.value.page = 1;
  getList();
};
// 获取父级分类
let catlist = ref({ id: "0", name: "全部" });
const getPaCategoryList = () => {
  parentCategoryApi()
    .then((res) => {
      catlist.value = res;
      catlist.value.unshift({ id: "0", name: "全部" });
    })
    .catch((err) => {
      console.log(err);
    });
};
// 获取分类列表
let headeNum = ref([]);
const getCategoryList = () => {
  categoryListApi({ pid: cuurentpa.value })
    .then((res) => {
      headeNum.value = res;
      formData.value.classId = res[0].id.toString();
    })
    .catch((err) => {
      console.log(err);
    });
};
// 获取商品列表
let productList = ref([]);
let total = ref(0);
const getList = () => {
  proListApi(formData.value)
    .then((res) => {
      productList.value = res.list;
      total.value = res.total;
    })
    .catch((err) => {
      console.log(err);
    });
};
// 联想搜索
const querySearchAsync = (queryString, cb) => {
  console.log(queryString);
  if (queryString) {
    keywordListApi({ keyword: queryString })
      .then((res) => {
        cb(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }
};
</script>
<style scoped lang='scss'>
.productbox {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 900px;
  .demo-pagination-block {
    height: 125px;
  }
  ::v-deep .el-tabs__nav.is-stretch {
    min-width: none !important;
  }
  ::v-deep .el-tabs__nav-wrap {
    padding-left: 41px;
  }
}

.productlist {
  flex-wrap: wrap;
  // justify-content: space-between;
  // align-items: flex-start;
  cursor: pointer;
  margin-top: 20px;
  // background-color: #f5f5f7;
  padding: 20px 0 20px 0;
  // justify-content: space-around;
}
.item {
  width:18.75%;
  min-width: 200px;
  margin-bottom: 20px;
  margin-right: 25px;
  background-color: #fff;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  // box-shadow: 1px 1px 10px 2px rgba(0, 0, 0, 0.2);
  padding-bottom: 20px;
  &:nth-child(5n){
    margin-right: 0;
  }
}
.contain {
  width: 1600px;
  max-width: 1600px;
  // background-color: #fff;
}
::v-deep .el-tabs__nav {
  .el-tabs__item {
    font-size: 20px;
  }
}
.productname {
  margin: 20px 0;
  width: 100%;
  height: 38px;
}
.seachbox {
  display: flex;
  justify-content: flex-end;
}
.picture {
  width: 100%;
  border-radius: 15px;
  img{
  border-radius: 15px;
  }
}
::v-deep .el-tabs {
  --el-tabs-header-height: 65px !important;
}
/* 当屏幕宽度小于等于1500px时应用此样式 */
@media screen and (max-width: 1500px) {
  .picture {
    width: 100px;
    height: 100px;
  }
  .item {
    width: 18%;
    font-size: 13px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  // ::v-deep .el-tabs__nav-wrap::after {
  //   display: none; /* 隐藏分隔线 */
  // }
  // ::v-deep .el-tabs__nav-scroll {
  //   overflow: auto; /* 允许滚动 */
  // }
  ::v-deep .el-tabs__nav .el-tabs__item {
    font-size: 14px !important;
  }
}
.catbox {
  display: flex;
  font-size: 23px;
  color: #303133;
  font-weight: 500;
  padding: 14px;
}
.catitem {
  margin-right: 50px;
  cursor: pointer;
  padding: 5px 10px;
}
.bgitem {
  background-color: #e7e7e7;
  padding: 5px 10px;
  border-radius: 35px;
}
.topboxs {
  display: flex;
  align-items: center;
}
.btnbox {
  background-color: #efefef;
  padding: 5px 10px;
  border-radius: 15px;
  color: #5f5f5f;
  cursor: pointer;
}
::v-deep .el-tabs__nav-next,::v-deep .el-tabs__nav-prev{
top: 13px;
}
</style>